<template>
  <div>
    <template v-if="isLaptop">
      <main class="main-container">
        <header class="dashboardAdmin-header d-flex">
          <img
            @click="goBack"
            src="../../assets/img/feedbackform/backarrow.svg"
            class="pointer"
            alt=""
          />
          <h5 class="dashboardAdmin-header-main-head mb-0 ml-2">
            {{ screenData.submitted ? "View" : "Give" }} Feedback
          </h5>
        </header>
        <div
          style="
            position: fixed;
            top: 20px;
            z-index: 2;
            backdrop-filter: blur(2px);
          "
          v-if="loaderStatus"
        >
          <Spinner />
        </div>

        <div class="givef-white-cont">
          <section class="givef-left-cont">
            <article
              class="
                givef-blue-header
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <h5 class="mb-0">Resume</h5>
              <div class="givef-tag d-flex align-items-center">
                <img src="../../assets/NewJobsRegis/AI small.svg" alt="" />
                <span
                  :style="
                    screenData.resumeRating && screenData.resumeRating >= 70
                      ? 'color: #038e00'
                      : 'color: #eb0002'
                  "
                >
                  {{ screenData.resumeRating }}% Match
                </span>
              </div>
            </article>
            <Resume
              :resume="screenData.candidate.resume"
              :candidate-name="screenData.candidate.name"
            />
          </section>
          <section class="givef-right-cont">
            <div class="newInt-control-tabs w-100">
              <b-tabs content-class="mt-1 position-relative">
                <b-tab
                  :title="
                    $route.query.feedbacktype == 'true'
                      ? 'Fill Feedback'
                      : screenData.submitted
                      ? 'View Feedback'
                      : 'Give Feedback'
                  "
                >
                  <FillFeedback
                    :feedback="feedback"
                    :screenData="screenData"
                    :validate="$v"
                    @submit-feedback="submitFeedback"
                    @go-back="goBack"
                    :feedbacktype="$route.query.feedbacktype || ''"
                  />
                </b-tab>
                <b-tab title="Job Description">
                  <JobDescription
                    :normalFields="normalFields"
                    :advancedFields="advancedFields"
                    :selectedJD="selectedJD"
                  />
                </b-tab>
                <b-tab title="CVS" v-if="showcvstab">
                  <CVSPreview
                    :candidatecvsdata="candidatecvsdata"
                    :selectedCvsIndex="selectedCvsIndex"
                    @scrollToTop="scrollTop('scrollToTop')"
                  />
                </b-tab>
              </b-tabs>
            </div>
          </section>
        </div>
      </main>
    </template>
    <template v-else>
      <div
        style="height: 100dvh; background: #e9ecef"
        class="bluebtn position-relative"
      >
        <div class="page-head-mob p-3" style="height: 60px">
          <img
            @click="goBackMobile"
            class="mr-3 mb-1 pointer"
            src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
            alt=""
          />Resume Screening
        </div>
        <div class="resscreening-innercontainer">
          <div class="rescreening newInt-control-tabs w-100">
            <b-tabs content-class="mt-1 position-relative">
              <b-tab title="Resume" class="position-relative">
                <div
                  class="
                    resume-tab-line
                    active-tab-indication
                    position-absolute
                  "
                ></div>
                <Resume
                  :resume="screenData.candidate.resume"
                  :candidate-name="screenData.candidate.name"
                />
              </b-tab>
              <b-tab
                :title="
                  $route.query.feedbacktype == 'true'
                    ? 'Fill Feedback'
                    : screenData.submitted
                    ? 'View Feedback'
                    : 'Give Feedback'
                "
              >
                <div
                  class="
                    fillfdbck-tab-line
                    active-tab-indication
                    position-absolute
                  "
                ></div>
                <FillFeedback
                  :feedback="feedback"
                  :screenData="screenData"
                  :validate="$v"
                  @submit-feedback="submitFeedback"
                  @go-back="goBackMobile"
                  :feedbacktype="$route.query.feedbacktype"
                />
              </b-tab>
              <b-tab title="Job Description">
                <div
                  class="
                    jobdesc-tab-line
                    active-tab-indication
                    position-absolute
                  "
                ></div>
                <JobDescription
                  :normalFields="normalFields"
                  :advancedFields="advancedFields"
                  :selectedJD="selectedJD"
                />
              </b-tab>
              <b-tab title="CVS" v-if="showcvstab">
                <div
                  class="cvs-tab-line active-tab-indication position-absolute"
                ></div>
                <CVSPreview
                  :candidatecvsdata="candidatecvsdata"
                  :selectedCvsIndex="selectedCvsIndex"
                  @scrollToTop="scrollTop('scrollToTop')"
                />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Resume from "./Resume.vue";
import FillFeedback from "./FeedbackForm.vue";
import JobDescription from "./JobDescription.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import FeedbackMixins from "./FeedbackMixins";
import CVSPreview from "../../components/PreviewCandidateSidebar/CVSPreview.vue";
import CVSPreviewMixin from "../../components/mixin/CVSPreviewMixin";
// import { getCVSDocuments } from "@/utils/apiFunctions";
export default {
  components: {
    JobDescription,
    Spinner,
    Resume,
    FillFeedback,
    CVSPreview,
  },
  data() {
    return {
      isLaptop: false,
      selectedCvsIndex: 0,
    };
  },
  mixins: [FeedbackMixins, CVSPreviewMixin],
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  created() {
    this.fetchCVSPreview(this.$route.query.candidateId).then(() => {
      if (this.candidatecvsdata.length > 0) {
        const firstCreatedAt = this.candidatecvsdata[0].createdAt;

        this.selectedCvsIndex = this.candidatecvsdata.findIndex(
          (data) => data.createdAt === firstCreatedAt
        );
      }
    });
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
  },
};
</script>

<style>
.givef-white-cont {
  background-color: #ffffff;
  box-shadow: 0px 0px 14px 0px #c4c4c480;
  border-radius: 5px;
  margin-top: 12px;
  height: calc(100vh - 160px);
  padding: 15px;
  display: flex;
  gap: 15px;
}
.givef-left-cont {
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  height: 100%;
  width: 55%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.givef-right-cont {
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  height: 100%;
  width: 45%;
}
.givef-blue-header {
  background-color: #e1eef7;
  border-radius: 8px 8px 0px 0px;
  padding: 10px 13px;
  width: 100%;
}
.givef-blue-header h5 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
}
.givef-tag {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #038e00;
  box-shadow: 5px 5px 7.5px 0px #0000000d;
  background-color: #f6f9fb;
  border-radius: 15px;
  padding: 2px 15px;
  gap: 5px;
}
.givef-tag img {
  height: 12px;
}
.givef-resume-cont {
  width: 70%;
  box-shadow: 0px 3.46px 13.58px 0px #00000040;
  border-radius: 5px;
  height: calc(100vh - 310px);
  overflow: auto;
  margin-top: 15px;
}
.givef-head {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #344054;
}
/* .givef-right-cont .form-control {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
} */
.givef-blue-skill {
  box-shadow: 0px 4px 4px 0px #00000014;
  background-color: #f3f6ff;
  border-radius: 8px;
  padding: 7px 12px;
  display: flex;
  align-items: center;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  gap: 5px;
}
.givef-feedback-card {
  border: 1px solid #8c8c8c54;
  box-shadow: 0px 4px 8px 0px #0000002b;
  border-radius: 8px;
  padding: 10px 15px;
  margin-top: 12px;
}
.feedback-rating .form-control {
  color: #20639b;
  background-color: transparent;
  border: none;
  width: unset;
  height: unset;
  padding: 0rem;
}
.givef-rating-txt {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #444444;
}
.givef-feedback-card .skill-txt {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}
.givef-footer {
  border-top: 1px solid #e4e7ec;
  padding: 10px;
  display: flex;
  justify-content: end;
}
.givef-right-overflow-2 {
  height: calc(100vh - 255px);
  overflow: auto;
}
.givef-right-overflow-2 article h4 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #3a3c40;
}
.givef-right-overflow-2 article h5 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #3a3c40;
}
.givef-right-overflow-2 article {
  margin-bottom: 20px;
}
.givef-line-txt {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #20639b;
  gap: 10px;
}
.givef-line {
  height: 1px;
  width: 80%;
  background-color: #dddddd;
}

.disablefeedbackcard {
  background: #f6f6f6;
  border: 1px solid rgba(140, 140, 140, 0.33);
  border-radius: 8px;
}
.givef-feedback-card .form-control:disabled {
  border: none;
}
.diable-cmnt-txt {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}
.viewfdbck-txtarea .form-control:disabled {
  padding: 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #3a3c40;
}
.screening-fdbck .form-control:disabled,
.form-control[readonly] {
  background: #f6f6f6;
}

.mob-fs-11 {
  font-size: 11px !important;
}
.mob-fw-500 {
  font-weight: 500 !important;
}
.color-3a3c40 {
  color: #3a3c40;
}
.gap-5 {
  gap: 5px;
}
@media (max-width: 1028px) {
  .newInt-control-tabs .nav-link {
    padding: 10px;
  }
  .newInt-control-tabs .nav-tabs {
    padding-left: 5px;
  }
  .newInt-control-tabs .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    font-size: 12px !important;
  }
  .newInt-control-tabs a {
    font-size: 12px;
    font-weight: 600;
  }
  .active-tab-indication {
    height: 2.52px;
    background: #20639b;
    border: 1px solid #20639b;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
    border-radius: 32px;
  }
  .newInt-control-tabs .nav-tabs .nav-link.active {
    border-bottom: unset !important;
  }
  .resume-tab-line {
    width: 65px;
    top: -10px;
    left: 7px;
  }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    background-color: unset;
  }
  .fillfdbck-tab-line {
    width: 84px;
    top: -10px;
    left: 76px;
  }
  .jobdesc-tab-line {
    width: 98px;
    top: -10px;
    left: 171px;
  }
  .givef-footer {
    padding: 6px 5px 0px 5px;
  }
  .cvs-tab-line {
    width: 45px;
    top: -10px;
    left: 275px;
  }
}
</style>
